import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceEventTypes, servicePermissionsTypes, serviceUserRightsTypes } from 'src/types';
import { urlHelper } from '../helpers';

export const lookupPermission = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: servicePermissionsTypes.PermissionsLookupDataType): AxiosPromise<servicePermissionsTypes.PermissionsLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  // if (ids) {
  //   query.ids = ids.join(',');
  // }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.permission.lookupPermission), {
    blockSpinner,
  });
};

// export const editPermission = (
//   form: serviceUserRightsTypes.UserRightsEditDataType,
// ): AxiosPromise<serviceUserRightsTypes.UserRightsEditDataType> => {
//   return axios.patch(urlsConfig.userRights.UserRightsEdit, form, { blockErrorHandler: true });
// };
